module.exports = __webpack_public_path__ + "assets/HKNova-ExtraBold.svg";


//////////////////
// WEBPACK FOOTER
// ./fonts/HKNova-ExtraBold.svg
// module id = 121
// module chunks = 0